import React from 'react';
import { Routes, Route } from 'react-router-dom';
import LuckyWheelLandingPage from './pages/LuckyWheelLandingPage';
import FootballPredictionPage from './pages/FootballPredictionPage';
import AdminLoginPage from './admin/AdminLoginPage';
import AdminDashboard from './admin/AdminDashboard';
import CardLandingPage from './card/CardLandingPage';
import CardLoginPage from './card/CardLoginPage';
import { CardAdminDashboard, CardAdminLogin } from './card/CardAdminApp';

function App() {
  const isCardSubdomain = window.location.hostname.toLowerCase().startsWith('card.');

  if (isCardSubdomain) {
    return (
      <Routes>
        <Route path="/" element={<CardLandingPage />} />
        <Route path="/login" element={<CardLoginPage />} />
        <Route path="/admin/login" element={<CardAdminLogin />} />
        <Route path="/admin/*" element={<CardAdminDashboard />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route path="/" element={<LuckyWheelLandingPage />} />
      <Route path="/card-preview" element={<CardLandingPage />} />
      <Route path="/football" element={<FootballPredictionPage />} />
      <Route path="/admin/login" element={<AdminLoginPage />} />
      <Route path="/admin/*" element={<AdminDashboard />} />
    </Routes>
  );
}

export default App;
